import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LogisticsService } from 'src/app/Services/Logistics/logistics.service'
import { DatePipe } from '@angular/common'
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { colors } from 'src/utils/colors';
import {  ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
//import { Script } from 'vm';


import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format,
} from 'date-fns';

interface Schedule {
  fullName: string;
  pickupTime: string;
  pid:string;
  phoneNumber:string;
  branch:string;
  salesRep:string;
   
 }

@Component({
  selector: 'app-schedule-edit',
  templateUrl: './schedule-edit.component.html',
  styleUrls: ['./schedule-edit.component.css']
})
export class ScheduleEditComponent implements OnInit {


    
 //_url= 'http://multiinspectionreport.com/reception/api';
 //_url= 'https://test.appointele.com/api';
 //_url= 'https://demo.appointele.com/api';
_url= 'https://ciot.appointele.com/api';
//_url= 'https://ciot.appointele.ca/api';

 
 color;
  events: any;
  items: Array<CalendarEvent<{ time: any }>> = [];
  viewDate: Date = new Date();
  view: CalendarView = CalendarView.Month;
  events$: Observable<CalendarEvent<{ schedule: Schedule }>[]>;
  activeDayIsOpen: boolean = false;


  loading=false;
  scheduleForm:FormGroup;
date;
  userschedule=[];
  error:any = '';
  success = '';
  branchs=[];
  salesRep=[];

  branch;

  branchselected=false;
questionaireForm:FormGroup;

loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;
currentUser:User;
role;
username;

  validationMessages = {
    'fullName': {
      'required': 'Full Name is required'
    },
    'phoneNumber': {
      'required': 'Phone Number is required'
    },
  
    'email': {
      'required': 'Email is required',
      'pattern' : 'Please enter a valid email'
    },
 
  //'whatLoveProduct': {
   // 'required': 'required'
  //},
  'status': {
    'required': 'required'
  }
  
  };
  
  
  formErrors = {
    'fullName': '',
    'phoneNumber': '',
    'email': '',
    'status': ''
  }
  

  constructor(private fb: FormBuilder,
    private router: Router,
    private _location: Location,
    private _http: HttpClient,
    private actroute: ActivatedRoute,
    private _logistics: LogisticsService,
    private _authenticationService: AuthenticationService,
    public datepipe: DatePipe) {

      
      this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
      if(this.currentUser){
        this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
        this.branch=this.currentUser.branch;
        this.role=this.currentUser.role;


  
        this.loggedInUserFullname= this.username;
        this.loggedInUserBranch= this.branch
        this.loggedInUserId=this.currentUser.userName;
    
        
    
       }
     }

  ngOnInit(): void {
    this.fetchEvents();
    this.getAllBranchs();
    this.loading=false;

    //actroute from tangibleasset
this.actroute.paramMap.subscribe(params => {
  // This is never executed, for route is not recognized
  // let myArray=params.getAll('extra');
  const pid = params.get('extra')
  const fullName = params.get('extra1')
  const phoneNumber = params.get('extra2')
  const branch = params.get('extra3');
  const pickupTime = params.get('extra4');
  //console.log(pid);
  if (pid) {
   // console.log(fullName);
    this.getScheduleToEdit(pid, fullName,phoneNumber,branch,pickupTime);
    this. getSalesRep(branch);
  //  this.viewMode = true;
  } else {
    //this.viewMode = false;
   // console.log('done');
  }
});


this.scheduleForm = this.fb.group({
  pid: new FormControl(''),
   fullName: new FormControl('', [Validators.required]),
   phoneNumber: new FormControl('',[Validators.required]),
   email: new FormControl(''),
   branch: new FormControl('',[Validators.required]),
   salesRepID: new FormControl(''),
   oldSalesRepID: new FormControl(''),
   requestType: new FormControl(''),
   invoiceNumber: new FormControl(''),
   status: new FormControl(''),
   pickupTime: new FormControl(''),
   checkOut: new FormControl(''),
   orderDescription: new FormControl(''),
   notes: new FormControl(''),

   
 });
  }




  onSubmit(){
    
    this.logValidationErrors(this.scheduleForm );
   
this.loading=true;

  console.log(this.scheduleForm.value);
         this._logistics.updateSchedule(this.scheduleForm.value)
      .subscribe(//subscribe to Observable
        response => {console.log('Success!', response);
        this.success=response['SUCCESS'];
        this.scheduleForm.reset;        
        document.getElementById("openSuccessModalButton").click();
      },
        error => {console.error('Error!', error);
        this.error=error.error.text ;
      }       
      );
  
          }



          getScheduleToEdit(pid, fullName,phoneNumber,branch,pickupTime) {
     
             this._logistics.getUserSchedule(pid,fullName,phoneNumber,branch,pickupTime).subscribe(
              response =>  {
                this.userschedule= response;

                console.log(this.userschedule);
                this.patchappointmentForm();
              },
              (err) => {
                this.error = err;
              }
            );
          
          }

          

          getSalesRep(branch){
          //  console.log(branch);
            if (branch != "None" || branch!="") {
              this._logistics.getSalesRepByBranch(branch).subscribe(
                (res) => {
                  this.salesRep = res;
                //  console.log(this.salesRep);
                  this.branchselected = true;
               
                }
                ,
                (err) => {
                  this.error = err;
                }
              );
            }
            else {
              this.branchselected = true;
            }
        

          }

          patchappointmentForm(){
           // this.branchselected = true;
        //  /   this. getSalesRep(this.userappointment[0].branch);
            this.scheduleForm.patchValue({
              // departmentId: assetformmodel[0].department,
               pid: this.userschedule[0].pid,
               fullName: this.userschedule[0].fullName,
               email: this.userschedule[0].email,
               phoneNumber: this.userschedule[0].phoneNumber,
               branch: this.userschedule[0].branch,
               pickupTime: this.userschedule[0].pickupTime,
               checkOut: this.userschedule[0].checkOut,
               clientele: this.userschedule[0].clientele,
               oldSalesRepID: this.userschedule[0].salesRepID,
               salesRepID: this.userschedule[0].salesRepID,
               invoiceNumber: this.userschedule[0].invoiceNumber,
               requestType: this.userschedule[0].requestType,
               dateSubmitted: this.userschedule[0].dateSubmitted,
               status: this.userschedule[0].status,
               orderDescription: this.userschedule[0].orderDescription,
               notes: this.userschedule[0].notes,
               

           
             });
          }


          patchPickupTime(){
            let dateTime = new Date();
            this.date=new Date();
 let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

            this.scheduleForm.patchValue({
              timeIn:latest_date
            });
          }



          patchCheckOut(){
            let dateTime = new Date();
            this.date=new Date();
 let latest_date =this.datepipe.transform(this.date, 'yyyy-MM-dd h:mm a');

            this.scheduleForm.patchValue({
              timeOut:latest_date
            });
          }





          
  getAllBranchs(){
    this._logistics.getAllBranchs().subscribe(
      (res) => {

        this.branchs = res;
      },
      (err) => {
        this.error = err;
      }
    );
  }

  backClicked() {
    this._location.back();
  }



  logValidationErrors(group: FormGroup ): void {
    //get the keys from FormGroup object and checks all the keys
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        //clear any previous error
        this.formErrors[key] = '';
        //check Validation of the formControl
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          //if not valid then get the error message of whatever the validation error is from the validationMessage method
          const messages = this.validationMessages[key];
          //for every error in validation get the error key and assign it to the formControl name is formError method
          for (const errorkey in abstractControl.errors) {
            if (errorkey) {
            //  console.log(key);

              this.formErrors[key] += messages[errorkey] + ''
            }
          }
        }
      }

    });
  }





  







 /************************************************************************************************************************** */
  //Calendar
  /**************************************************************************************************************************** */
  fetchEvents(): void {

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay,
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay,
    }[this.view];

  this.events$ = this._http.get(`${this._url}/active_all_logistics_schedules_for_branch_get.php?branch=${this.branch}`)
  .pipe(
    map(({ results }: { results: Schedule[] }) => {
      console.log(results);
      return results.map((schedule: Schedule) => {
        this.colorForRep(schedule.salesRep);
     /**   if(appointment.salesRep=='Nicolas Salazar'){
          this.color=colors.blue;
        }else if(appointment.salesRep=='Tom Kizito'){
          this.color=colors.yellow;
        }**/
        return {
         
          title: schedule.fullName+' - '+(new Date(schedule.pickupTime).toLocaleTimeString()).replace(/:\d+ /, ' ')+' - '+schedule.salesRep,
          start: new Date(
            schedule.pickupTime
          ),
          
          color:this.color,
         // cssClass: main-dashboard.component.css,
          meta: {
            schedule,
          },

        };
      });
    })
  );


}


dayClicked({
  date,
  events,
}: {
  date: Date;
  events: CalendarEvent<{ schedule: Schedule }>[];
}): void {
  if (isSameMonth(date, this.viewDate)) {
    if (
      (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
      events.length === 0
    ) {
      this.activeDayIsOpen = false;
    } else {
      this.activeDayIsOpen = true;
      this.viewDate = date;
    }
  }

}



eventClicked(event: CalendarEvent<{ schedule: Schedule }>): void {
  /**window.open(
    `https://multiinspectionreport.com/reception/appointment-details;extra=${event.meta.appointment.appointmentID};extra1=${event.meta.appointment.fullName};extra2=${event.meta.appointment.phoneNumber}`,
    '_blank'
  );**/

  console.log(event.meta.schedule);
  if(event.meta.schedule.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:event.meta.schedule.pid,extra1:event.meta.schedule.pickupTime,extra2:event.meta.schedule.salesRep,extra3:event.meta.schedule.branch}],{relativeTo:this.actroute});
  }else{
 
  this.router.navigate(['../schedule-details', { extra:event.meta.schedule.pid, extra1: event.meta.schedule.fullName,extra2:event.meta.schedule.phoneNumber,extra3:event.meta.schedule.branch }], { relativeTo: this.actroute });
}
}







colorForRep(salesRep){
  if(salesRep=='Nicolas Salazar'){
    this.color=colors.darkgray;
  }else if(salesRep=='Sonia Garofolo'){
    this.color=colors.yellow;
  } else if(salesRep=='Nancy Ventura'){
    this.color=colors.purple;
  }else if(salesRep=='Olivia Dobrovich'){
    this.color=colors.pink;
  } else if(salesRep=='Jason Branco'){
    this.color=colors.green;
  }else if(salesRep=='Ryan Li'){
    this.color=colors.darkgreen;
  } else if(salesRep=='Caelyn Huang'){
    this.color=colors.purpleblue;
  }else if(salesRep=='Alyssa Vani'){
    this.color=colors.info;
  } else if(salesRep=='Alex Karlee Lafarciola'){
    this.color=colors.brightblue;
  }else if(salesRep=='Magdalena Wojtachnio'){
    this.color=colors.orange;
  } else if(salesRep=='Christelle Aniceto'){
    this.color=colors.lightgray;
  }else if(salesRep=='Zach Cannarozzo'){
    this.color=colors.blue;
  } else if(salesRep=='Alexia Rupolo'){
    this.color=colors.brown;
  }else if(salesRep=='Sandra Arango'){
    this.color=colors.red;
  } else if(salesRep=='Lauren Richardson'){
    this.color=colors.coralred;
  }else {
    this.color=colors.black;
  }

}



}
